import "./index.css";
import { Controller, useFormContext } from "react-hook-form";
import TextArea from "../text-area";
import { FormInputs } from "./index.types";

export function FormTextArea({ name, isRequired, error, ...rest }: FormInputs) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(isRequired
          ? {
              required: (error?.message as any) || "Field is required",
            }
          : {}),
      }}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextArea
            isRequired
            error={{
              is: !!error,
              message: error?.message,
            }}
            {...field}
            {...rest}
          />
        );
      }}
    />
  );
}

export default FormTextArea;
